
<div
  class="rfp-rr-most-helpful-favorable-review-133-or rr-most-fav-review-left float-left"
  :class="{ 'rfp-rr-rating-rtl': isRightToLeftActiveMhfr }"
>
  <div class="rfp-rr-most-helpful-favorable-review-134-or rr-most-fav-review-left-inner">
    <h3 class="rfp-rr-most-helpful-favorable-review-135-or rr-sub-title black">
      {{ headerTitleMhfr }}
    </h3>
    <span v-if="noFavorableReviewFoundMhfr">
      <span
        class="rfp-rr-most-helpful-favorable-review-136-or review-stars"
        :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActiveMhfr }"
      >
        <vue-star-rating
          :increment="starRatingIncrementValueMhfr"
          :max-rating="starRatingMaxRatingValueMhfr"
          :inactive-color="starRatingInactiveColorMhfr"
          :active-color="starRatingActiveColorMhfr"
          :star-size="starRatingStarSizeMhfr"
          :rating="overallRating"
          :read-only="true"
          :show-rating="false"
        >
        </vue-star-rating>
      </span>
      <p class="rfp-rr-most-helpful-favorable-review-138-or clear">
        <span
          v-if="showHideNicknameMhfr"
          class="rfp-rr-most-helpful-favorable-review-139-or black bold"
          >{{ labelDateMhfr }}</span
        ><span v-if="showCreatedAtMhfr"> - {{ reviewDateMhfr }}</span>
      </p>
      <h3
        v-if="showHideSubTitleMhfr"
        class="rfp-rr-most-helpful-favorable-review-140-or rr-sub-title black clear"
      >
        {{ subTitleMhfr }}
      </h3>
      <p class="rfp-rr-most-helpful-favorable-review-141-or clear">
        <span class="rfp-rr-most-helpful-favorable-review-142-or rr-sub-content-restricted"
          >{{ subContentMhfr }}
        </span>
        <span
          class="rfp-rr-most-helpful-favorable-review-143-or bold rr-show-full-review"
          @click="showFullReviewPopup"
          >{{ showFullReviewMhfr }}</span
        >
      </p>
      <p
        v-if="isProductFreeMhfr && showFreeProductMhfr"
        class="rfp-rr-most-helpful-favorable-review-152-or"
      >
        <span>{{ isProductFreeDisplayTextMhfr }}</span>
      </p>
      <p class="rfp-rr-most-helpful-favorable-review-144-or clear">{{ labelHelpfulMhfr }}</p>
      <p
        class="rfp-rr-most-helpful-favorable-review-145-or clear bold rr-see-more-reviews reviews-four-five"
        @click="filterRatingSpecific"
      >
        {{ filterStarReviewsMhfr }}
      </p>
      <p
        v-if="commentAddedMhfr != ''"
        class="rfp-rr-most-helpful-favorable-review-146-or clear bold rr-see-more-reviews reviews-four-five"
        @click="showComments"
      >
        {{ commentAddedButtonMhfr }}
      </p>
      <p
        v-if="showCommentText"
        class="rfp-rr-most-helpful-favorable-review-147-or comment___text"
      >
        {{ commentAddedMhfr }}
      </p>
    </span>
    <span
      v-if="!noFavorableReviewFoundMhfr"
      class="rfp-rr-most-helpful-favorable-review-148-or"
      >{{ noFavorableReviewFoundTextMhfr }}</span
    >
  </div>
  <div
    v-if="activePopup"
    class="rfp-rr-most-helpful-favorable-review-149-or review-popup-overlay"
    style="display: block"
  ></div>
  <rfp-ratings-show-full-review
    v-if="activePopup"
    :header-title="headerTitlePopupMhfr"
    :label-quality-of-product="labelQualityOfProductMhfr"
    :rate-quality-of-product="rateQualityOfProductMhfr"
    :summary="summaryMhfr"
    :rrids="rridMhfr"
    :helpful-labels="helpfulLabelMhfr"
    :reports="reportMhfr"
    :reported-texts="reportedTextMhfr"
    :report-texts="reportTextMhfr"
    :reported-counts="reportedCountMhfr"
    :is-helpful-cookies="isHelpfulCookieMhfr"
    :helpful-counts="helpfulCountMhfr"
    :not-helpful-counts="notHelpfulCountMhfr"
    :update-helpful-review-apis="updateHelpfulReviewApiMhfr"
    :update-not-helpful-review-apis="updateNotHelpfulReviewApiMhfr"
    :report-review-apis="reportReviewApiMhfr"
    :is-recommends="isRecommendMhfr"
    :helpful-icons="helpfulIconMhfr"
    :helpful-icon-alts="helpfulIconAltMhfr"
    :non-helpful-icons="nonHelpfulIconMhfr"
    :non-helpful-icon-alts="nonHelpfulIconAltMhfr"
    :recommend-list-icons="recommendListIconMhfr"
    :recommend-icon-alt-texts="recommendIconAltTextMhfr"
    :product-names="productNameMhfr"
    :review-contents="subContentMhfr"
    :review-titles="subTitleMhfr"
    :facebook-captions="facebookCaptionMhfr"
    :facebook-share-enableds="facebookShareEnabledMhfr"
    :share-display-configs="shareDisplayConfigMhfr"
    :facebook-icons="facebookIconMhfr"
    :facebook-icon-alts="facebookIconAltMhfr"
    :facebook-tool-tips="facebookToolTip"
    :show-hode-quality-of-products="showHodeQualityOfProductMhfr"
    :show-hide-sub-titles="showHideSubTitleMhfr"
  >
  </rfp-ratings-show-full-review>
</div>
